import { useState } from "react";
import Image from "next/image";
import { getMediaRecordPath, getMediaUrl } from "@/utils/media";

const PlaceMenuMedia = ({
  menuId,
  menuFilePath,
  menuMedia,
  index,
  className,
  openPlaceMediaSlider,
}) => {
  const imageSizes = className?.includes("aspect-square")
    ? "(max-width: 640px) 44vw, (max-width: 1024px) 180px, 220px"
    : "112px";
  const [filePath] = useState(
    getMediaRecordPath(menuMedia, { variant: "thumbnail" }) ||
      menuFilePath ||
      null
  );
  const sliderPath =
    getMediaRecordPath(menuMedia, { variant: "large" }) || menuFilePath || null;

  if (!filePath) return null;

  return (
    <Image
      src={getMediaUrl(filePath)}
      alt="food menu"
      width={320}
      height={320}
      sizes={imageSizes}
      quality={90}
      className={`w-28 shrink-0 h-28 border dark:border-brown rounded-2xl overflow-hidden object-cover hover:brightness-75 transition cursor-pointer ${className}`}
      onClick={() => openPlaceMediaSlider([sliderPath || filePath], index)}
    />
  );
};

export default PlaceMenuMedia;
